jQuery(document).ready(function ($) {
  var webTicker = $(
    ".infinite-scroll-carousel__icons-ticker-container"
  ).webTicker({
    height: "100%",
    duplicate: true,
    startEmpty: false,
  });
});
